import moment from 'moment';
import { API } from '@/config';

const defaultUserData = {
  access: {},
  account: {},
  profile: {},
};

export default {
  namespaced: true,
  state: {
    isAuthenticated: false,
    isWaitingForAuthorisation: false,
    user: null,
  },

  getters: {
    isAuthenticated: state => state.isAuthenticated,
    isWaitingForAuthorisation: state => state.isWaitingForAuthorisation,
    user: state => state.user,
    accessPermissionsDefinitions: state => state.user.access.permissions.definitions,
    isAccessExpired: (state) => {
      const { access } = state.user;

      if (access.account_type !== 'prepaid') {
        return false;
      }

      if (access.account_balance + access.account_balance_of_recording <= 0) {
        return true;
      }

      if (!moment().isBefore(access.account_expiration_date)) {
        return true;
      }

      return false;
    },
    hasRequiredAccountData: state => !!state.user.account.company_name
        && !!state.user.account.company_address
        && !!state.user.account.company_postal_code
        && !!state.user.account.company_city,
    acl: state => ({
      hasPermission(permission) {
        const userPermisions = state.user.profile.permissions ? state.user.profile.permissions.split(',') : [];
        return userPermisions.some(_permission => (typeof permission === 'string' ? _permission === permission : permission.includes(_permission)));
      },
    }),
  },

  mutations: {
    SET_AUTHENTICATED(state, payload) {
      const _state = state;
      _state.isAuthenticated = payload;
      _state.isWaitingForAuthorisation = false;
    },
    SET_WAITING_FOR_AUTHORISATION(state, payload) {
      const _state = state;
      _state.isWaitingForAuthorisation = payload;
    },
    SET_USER_DATA(state, payload) {
      const _state = state;
      _state.user = payload;
    },
  },

  actions: {
    async loginToPlatform({ commit }, { endpoint, params }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        const { url } = (await API.post(endpoint, params)).data.data;
        return url;
      } catch (err) {
        commit('SET_AUTHENTICATED', false);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
        return Promise.reject();
      }
    },
    async logoutFromPlatform({ commit }, { endpoint }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        await API.delete(endpoint);
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER_DATA', defaultUserData);
        return;
      } catch (err) {
        commit('SET_AUTHENTICATED', true);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
      }
    },
    async checkIfUserSessionExists({ commit }, { endpoint }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        const user = (await API.get(endpoint)).data.data;
        commit('SET_USER_DATA', user);
        commit('SET_AUTHENTICATED', true);
      } catch (err) {
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER_DATA', defaultUserData);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
      }
    },
    async registerToPlatform({ commit }, { endpoint, params }) {
      commit('SET_WAITING_FOR_AUTHORISATION', true);
      try {
        const { url } = (await API.post(endpoint, params)).data.data;
        return url;
      } catch (err) {
        commit('SET_AUTHENTICATED', false);
        commit('SET_WAITING_FOR_AUTHORISATION', false);
        return null;
      }
    },
  },
};
